<script setup lang="ts">
    import { ref } from 'vue';
    import { TaskTemplate } from '@/types';
    import { useForm } from '@inertiajs/vue3';
    import { useI18n } from 'vue-i18n';
    import AddButton from '@/components/AddButton.vue';
    import DialogForm from '@/components/DialogForm.vue';
    import QueryKey from '@/enums/QueryKey';
    import TaskTemplateForm from './TaskTemplateForm.vue';

    const { t } = useI18n();

    const taskTemplateForm = ref<InstanceType<typeof TaskTemplateForm>>();

    const props = defineProps<{
        taskTemplate: TaskTemplate;
    }>();

    const form = useForm({
        name: props.taskTemplate.name,
        description: props.taskTemplate.description,
        tasks: props.taskTemplate.tasks.map((task) => ({
            title: task.title,
            description: task.description,
            weekdays: task.weekdays ? task.weekdays.split(',').map((day) => day.trim()) : [],
            status: task.status,
            responsible_id: task.responsible_id,
            send_notification: task.send_notification,
            notification_recurring_week: task.notification_recurring_week,
            notification_recurring_even_week: task.notification_recurring_even_week,
            notification_recurring_start_of_month: task.notification_recurring_start_of_month,
        })),
    });
</script>

<template>
    <DialogForm
        type="update"
        :form="form"
        :route="route('v2.task-templates.update', taskTemplate.id)"
        method="patch"
        :query-key="[QueryKey.TASK_TEMPLATES]"
        title="task-templates.edit_txt"
        modal-size="sm:max-w-3xl"
    >
        <TaskTemplateForm
            ref="taskTemplateForm"
            :form="form"
        />
        <template #footerActions>
            <AddButton
                class="mr-auto"
                @click.prevent="taskTemplateForm?.addTask()"
            >
                {{ t('task-templates.add_task') }}
            </AddButton>
        </template>
    </DialogForm>
</template>
